import type * as React from 'react';
import { ConfigurationSubCard } from '../ConfigurationSubCard.tsx';

export type WidgetConfigurationSubCardProps = React.ComponentProps<
  typeof ConfigurationSubCard
>;

/**
 * Alias del `ConfigurationSubCard` per il Drawer di configurazione dei Widget.
 */
export function WidgetConfigurationSubCard(
  props: WidgetConfigurationSubCardProps,
) {
  return <ConfigurationSubCard {...props} />;
}
